// extracted by mini-css-extract-plugin
export default {"fields":"modules__common__task__task-right-menu__fields","group":"modules__common__task__task-right-menu__group","group_view":"modules__common__task__task-right-menu__group_view"};